module.exports = "/_next/static/images/Frame@2x-209115bc187d0b71e49dd24bc3282078.png";